import React from 'react'
import type { ViewProps } from 'react-native'
import { Text, View } from 'react-native'
import { twMerge } from 'tailwind-merge'

import Separator from '@ui-kit/components/layoutComponents/Separator'
import { body1 } from '@ui-kit/core/typography'
import { textColor } from '@ui-kit/styles/colors'
import { gapY } from '@ui-kit/styles/gap'

import * as styles from './styles'
import type { LineListItem as LineListItemProps, Props } from './types'

const LineListItem = (
  props: LineListItemProps & { labelVariant: 'body2' | 'h5'; style?: ViewProps['style'] }
) => {
  const { mainItem, label, rightGroup, value, subItemsList, subItem } = styles.lineListItem({
    labelVariant: props.labelVariant,
    isBold: props.isBold,
    isValueBody1: props.isBodySize,
  })
  return (
    <>
      <View className={mainItem()} style={props.style}>
        <Text
          className={twMerge(
            label({
              className: textColor({ color: props.labelColor }),
            })
          )}
        >
          {props.label}
        </Text>
        <View className={rightGroup()}>
          {props.value ? (
            <Text
              className={twMerge(
                value({
                  className: textColor({ color: props.valueColor }),
                }),
                props.crossedOutValue && 'line-through'
              )}
            >
              {props.value}
            </Text>
          ) : null}
          {props.component}
        </View>
      </View>
      {props.subItems && props.subItems.length > 0 && (
        <View className={subItemsList()} style={props.style}>
          {props.subItems.map((item) => (
            <Text className={subItem()} key={item.key}>
              {`${item.label} ${item.value ? item.value : ''}`}
            </Text>
          ))}
        </View>
      )}
    </>
  )
}

const LineListItemOrSeparator = (props: Props['data'][number]) => {
  if ('type' in props && props.type === 'separator') {
    return <Separator {...props} />
  }
  if ('label' in props) {
    return <LineListItem {...props} labelVariant="body2" />
  }
  throw new Error('Item in the LineList not supported')
}

const LineList = (props: Props): JSX.Element => {
  const { container, dataContainer } = styles.lineListContainer()
  return (
    <View className={twMerge(container(), gapY({ space: props.gapY ?? 'medium' }))}>
      {props.listLabel !== undefined && (
        <Text className={body1({ bold: props.isBoldLabel })}>{props.listLabel}</Text>
      )}
      <View className={dataContainer()}>
        {props.data.map((item) => (
          <LineListItemOrSeparator {...item} key={item.key} />
        ))}
        {props.summaryData && <Separator space="none" color="uiGreyDark" />}
        {props.summaryData?.map((item) => (
          <LineListItem {...item} key={item.key} labelVariant="h5" />
        ))}
      </View>
    </View>
  )
}

export default LineList
